/**
 * Get DELIVERY_CONFIGURATION
 */
export const GET_DELIVERY_CONFIGURATION = "GET_DELIVERY_CONFIGURATION";
export const GET_DELIVERY_CONFIGURATION_SUCCESS =
    "GET_DELIVERY_CONFIGURATION_SUCCESS";
export const GET_DELIVERY_CONFIGURATION_FAIL =
    "GET_DELIVERY_CONFIGURATION_FAIL";
/**
 * Set DELIVERY_CONFIGURATION
 */
export const SET_DELIVERY_CONFIGURATION = "SET_DELIVERY_CONFIGURATION";
export const SET_DELIVERY_CONFIGURATION_SUCCESS =
    "SET_DELIVERY_CONFIGURATION_SUCCESS";
export const SET_DELIVERY_CONFIGURATION_FAIL =
    "SET_DELIVERY_CONFIGURATION_FAIL";
/**
 * Delete DELIVERY_CONFIGURATION
 */
export const DELETE_DELIVERY_CONFIGURATION = "DELETE_DELIVERY_CONFIGURATION";
export const DELETE_DELIVERY_CONFIGURATION_SUCCESS =
    "DELETE_DELIVERY_CONFIGURATION_SUCCESS";
export const DELETE_DELIVERY_CONFIGURATION_FAIL =
    "DELETE_DELIVERY_CONFIGURATION_FAIL";
/**
 * Hide notification
*/
export const HIDE_NOTIFICATION = "HIDE_NOTIFICATION";